export const COLLECTION_PRESET_COLORS = [
  { label: 'Violet', value: '#7F77DD' },
  { label: 'Menthe', value: '#5DCAA5' },
  { label: 'Bleu', value: '#378ADD' },
  { label: 'Ambre', value: '#EF9F27' },
  { label: 'Rouge', value: '#E24B4A' },
  { label: 'Rose', value: '#D4537E' },
  { label: 'Vert', value: '#639922' },
  { label: 'Gris', value: '#888780' },
] as const
